"use client";

import { Button } from "@cartridge/controller-ui";
import {
  useAccount,
  useNetwork,
  useSendTransaction,
} from "@starknet-start/react";
import { useCallback, useState } from "react";
import { STRK_CONTRACT_ADDRESS } from "@cartridge/controller-ui/utils";

export const Transfer = () => {
  const [submitted, setSubmitted] = useState<boolean>(false);
  const { address } = useAccount();
  const { sendAsync } = useSendTransaction({});
  const { chain } = useNetwork();
  const [txnHash, setTxnHash] = useState<string>();
  const [network, setNetwork] = useState<string>();

  const execute = useCallback(
    async (amount: string) => {
      if (!address) {
        return;
      }
      setSubmitted(true);
      setTxnHash(undefined);

      sendAsync([
        ...(amount != "0x0"
          ? [
              {
                contractAddress: STRK_CONTRACT_ADDRESS,
                entrypoint: "approve",
                calldata: [address, amount, "0x0"],
              },
            ]
          : []),
        {
          contractAddress: STRK_CONTRACT_ADDRESS,
          entrypoint: "transfer",
          calldata: [address, amount, "0x0"],
        },
      ])
        .then(({ transaction_hash }) => {
          setTxnHash(transaction_hash);
          setNetwork(chain.network);
        })
        .catch((e) => console.error(e))
        .finally(() => setSubmitted(false));
    },
    [address, chain, sendAsync],
  );

  if (!address) {
    return null;
  }

  return (
    <div>
      <h2>Session Transfer STRK</h2>

      <div className="flex flex-wrap gap-1">
        <Button onClick={() => execute("0x0")}>Transfer 0 STRK to self</Button>
        <Button onClick={() => execute("0x1C6BF52634000")} disabled={submitted}>
          Transfer 0.005 STRK to self
        </Button>
        <Button
          onClick={() => execute("1B1AE4D6E2EF500000")}
          disabled={submitted}
        >
          Transfer 500 STRK to self
        </Button>
        {txnHash && (
          <>
            <p>Transaction: {txnHash}</p>
            <p>Chain: {network}</p>
          </>
        )}
      </div>
    </div>
  );
};
